import React from 'react'
import { useForm } from "react-hook-form";
import {
    FormControl,
    FormErrorMessage,
    Button,
    FormLabel,
    Input,
    Text,
    Flex,
    Box,
    useColorMode
} from '@chakra-ui/core';
import { apiUrl } from '../config/keys';
import Axios from 'axios'

const SignUp = ({ history }) => {

    const [submitting, setSubmitting] = React.useState(false);
    const { handleSubmit, errors, register } = useForm();
    const { colorMode } = useColorMode();
    const onSubmit = (values) => {
        setSubmitting(true)
        Axios.post(`${apiUrl}/restro/signup`, {
            _id: "807704",
            fullname: values.fullname,
            name: values.resname,
            address: values.address,
            phone: values.phno,
            email: values.email,
            password: "12345678"
        })
            .then(res => {
                console.log(res.data);
                if(!res.data.error)
                    history.push('/dashboard')
            })
        setSubmitting(false);
    }

    return (
        <div>
            <Flex align="center" justify="center" mt={5}>
                <Box width={[
                    "90%", // base
                    "50%", // 480px upwards
                    "50%", // 768px upwards
                    "40%", // 992px upwards
                ]} borderWidth="1px" rounded="lg" overflow="hidden" boxShadow="md">

                    <Box>
                        <Text
                            p={5}
                            textAlign="center"
                            fontSize="3xl"
                            fontWeight="bold"
                            color={colorMode === "dark" ? "brand.400" : "brand.500"}
                        >Sign Up</Text>
                    </Box>

                    <Box bg={colorMode === "dark" ? "gray.700" : "gray.100"} p={10}>
                        <Box as="form" onSubmit={handleSubmit(onSubmit)}>

                            <FormControl m={4} isInvalid={errors.fullname}>
                                <FormLabel htmlFor="fullname">Full Name</FormLabel>
                                <Input
                                    name="fullname"
                                    placeholder="Fullname"
                                    ref={register({ required: "Fullname is Required" })}
                                />
                                <FormErrorMessage>
                                    {errors.fullname && errors.fullname.message}
                                </FormErrorMessage>
                            </FormControl>

                            <FormControl m={4} isInvalid={errors.fullname}>
                                <FormLabel htmlFor="resname">Restraunt Name</FormLabel>
                                <Input
                                    name="resname"
                                    placeholder="Restraunt Name"
                                    ref={register({ required: "Restraunt Name is Required" })}
                                />
                                <FormErrorMessage>
                                    {errors.resname && errors.resname.message}
                                </FormErrorMessage>
                            </FormControl>

                            <FormControl m={4} isInvalid={errors.phno}>
                                <FormLabel htmlFor="phno">Phone Number</FormLabel>
                                <Input
                                    name="phno"
                                    placeholder="Phone Number"
                                    ref={register({ required: "Phone Number is Required" })}
                                />
                                <FormErrorMessage>
                                    {errors.phno && errors.phno.message}
                                </FormErrorMessage>
                            </FormControl>

                            <FormControl m={4} isInvalid={errors.address}>
                                <FormLabel htmlFor="address">Address</FormLabel>
                                <Input
                                    name="address"
                                    placeholder="Address"
                                    ref={register({ required: "Address is Required" })}
                                />
                                <FormErrorMessage>
                                    {errors.address && errors.address.message}
                                </FormErrorMessage>
                            </FormControl>

                            <FormControl m={4} isInvalid={errors.email}>
                                <FormLabel htmlFor="email">Email</FormLabel>
                                <Input
                                    name="email"
                                    placeholder="Email"
                                    ref={register({ required: "Username is Required" })}
                                />
                                <FormErrorMessage>
                                    {errors.email && errors.email.message}
                                </FormErrorMessage>
                            </FormControl>

                            <Button
                                mt={4}
                                ml={4}
                                rightIcon="arrow-forward"
                                variantColor="green"
                                loadingText="Submitting"
                                isLoading={submitting}
                                type="submit"
                            >
                                Submit
                        </Button>
                        </Box>
                    </Box>
                </Box>
            </Flex>
        </div>
    )
}

export default SignUp
